import axios from 'axios'
import * as common from '../utils/common'

const getArtUrl = (type, seq) => (
  // `/pclient/${type}/608146444.json`
  `/pclient/${type}/${seq}.json`
  // `/${type}/${seq}.json`
)
const getCommentUrl = (seq) => (
  `//comment.10jqka.com.cn/hotcommentv2/${seq.toString().slice(0, 3)}/${seq}.${common.getDateText()}.txt`
)
const loadCommentUrl = () => (
  `//t.10jqka.com.cn/api.php?method=newcircle.getCommentFlow`
)
const getArtLikesUrl = (seq) => (
  `//comment.10jqka.com.cn/api/faceajax/list/${seq}/`
)
const getArtLikesNewUrl = () => (
  `//bbsclick.10jqka.com.cn/getlist`
)
const setArtLikeUrl = (seq) => (
  `//comment.10jqka.com.cn/faceajax.php?type=add&jsoncallback=showFace&faceid=2&seq=${seq}`
)
const setArtLikeNewUrl = () => (
  `//bbsclick.10jqka.com.cn/inc`
)
const addCollectUrl = () => (
  `//comment.10jqka.com.cn/collect/index.php?act=addCollect&jsoncallback=addCollect`
)
// 获取评论点赞
const getCommentLikesUrl = (keys) => (
  `//bbsclick.10jqka.com.cn/clicks.php?key=${keys}`
)
const setCommentLikeUrl = (key) => (
  `//bbsclick.10jqka.com.cn/clicks.php?key=${key}`
)
const sendCommentUrl = () => (
  `//t.10jqka.com.cn/api.php`
)
const sendReplyUrl = () => (
  `//t.10jqka.com.cn/api.php`
)
const createPidUrl = (seq) => (
  `//comment.10jqka.com.cn/commentcheck.php?act=inic&seq=${seq}&nojsonp=1`
)
const getListDataUrl = (stockCode, tag, lastSeq) => (
  `//news.10jqka.com.cn/thsclientapi/Newssearch/getnews/${stockCode}_${tag}_${lastSeq}.json`
)
const getReportListDataUrl = (stockCode, ts) => (
  `//news.10jqka.com.cn/thsclientlistapi/Newslist/getRecent/sr_${stockCode}/_${ts}.json`
)
const getNoticeListDataUrl = (stockCode, ts) => (
  `//news.10jqka.com.cn/thsclientlistapi/Newslist/getRecent/sn_${stockCode}/_${ts}.json`
)

let artSource = null

/**
 * 获取文章
 *
 * @param {String} type 文章类别（news、notice、report）
 * @param {Number} seq 文章seq
 * @return {Promise}
 */
export function getArt (type, seq) {
  artSource = axios.CancelToken.source()
  return axios({
    method: 'get',
    url: getArtUrl(type, seq),
    cancelToken: artSource.token
  })
}

/**
 * 取消请求
 */
export function cancelGetArt () {
  if (artSource) {
    artSource.cancel()
    artSource = null
  }
}

/**
 * 获取评论
 */
export function getComment (seq) {
  return this.$jsonp(getCommentUrl(seq), {
    callbackName: 'getHotCommentList'
  })
}

/**
 * 加载更多评论
 *
 * @param {Number} seq 文章 seq
 * @param {String} date 日期字段拼接，如： 2018年9月25日15点09分 -> 201809251509
 * @return {Promise}
 */
export function loadComment (opt) {
  return this.$jsonp(loadCommentUrl(), {
    pid: opt.pid,
    cid: opt.cid || 0,
    limit: 10,
    sort: 'down',
    return: 'jsonp',
    callbackName: 'loadHotCommentList'
  })
}

/**
 * 获取文章点赞数
 */
export function getArtLikes (seq) {
  console.log('index获取文章点赞数2', seq)
  return this.$jsonp(getArtLikesUrl(seq), {
    callbackName: 'faceajaxCallback'
  })
}

/**
 * 获取文章点赞数（手炒方法）
 */
export function getArtLikesNew (seq) {
  console.log('index获取文章点赞数', seq)
  return this.$jsonp(getArtLikesNewUrl(), {
    field: 'likes',
    key: `seq_${seq}`,
    app: 'sns',
    log: 1,
    return: 'jsonp',
    callbackName: 'jsonp1'
  })
}

/**
 * 执行点赞
 */
export function setArtLike (seq) {
  return this.$jsonp(setArtLikeUrl(seq), {
    callbackName: 'showFace'
  })
}

/**
 * 执行点赞（手炒方法）
 */
export function setArtLikeNew (seq, authen) {
  return this.$jsonp(setArtLikeNewUrl(), {
    field: 'likes',
    key: `seq_${seq}`,
    app: 'news',
    inc: 1,
    token: authen,
    return: 'jsonp',
    callbackName: 'jsonp5'
  })
}

/**
 * 添加收藏
 * @param {Object} opt 收藏内容
 * {
 *    title
 *    data
 *    stock
 *    sourceId
 *    url
 * }
 */
export function addCollect (opt) {
  return this.$jsonp(addCollectUrl(), {
    title: opt.title || '',
    data: opt.data || '',
    stock: opt.stock || '',
    sourceId: opt.sourceId || 0,
    url: opt.url || '',
    callbackName: 'addCollect'
  })
}

/**
 * 获取评论点赞数
 * @param {Array} keys seq 数组
 */
export function getCommentLikes (keys) {
  console.log('index评论点赞keys', keys)
  return this.$jsonp(getCommentLikesUrl(keys.join(',')), {
    type: 'likes',
    action: 'getList',
    app: 'sns',
    return: 'jsonp',
    parent: 'pid',
    callbackName: 'jsonp4'
  })
}

/**
 * 评论点赞
 * @param {Array} keys seq 数组
 */
export function setCommentLike (key) {
  return this.$jsonp(setCommentLikeUrl(key), {
    type: 'likes',
    action: 'add',
    app: 'sns',
    return: 'jsonp',
    parent: 'pid',
    num: 1,
    callbackName: 'jsonp7'
  })
}

/**
 * 发送评论
 */
export function sendComment (opt) {
  return this.$jsonp(sendCommentUrl(), {
    method: 'newcircle.addComment',
    return: 'jsonp',
    rid: '0',
    content: opt.cont || '',
    userid: opt.userid || 0,
    uname: opt.uname || '',
    avatar: opt.avatar || '',
    utime: opt.utime || '',
    to: opt.to || 0,
    pid: opt.pid || 0,
    callbackName: 'sendComment'
  })
}

/**
 * 创建 pid
 * @param {Number} seq 文章seq
 */
export function createPid (seq) {
  return axios({
    url: createPidUrl(seq)
  })
}

/**
 * 回复评论
 */
export function sendReply (opt) {
  return this.$jsonp(sendReplyUrl(), {
    method: 'newcircle.addComment',
    return: 'jsonp',
    rid: opt.rid || 0,
    content: opt.cont || '',
    userid: opt.userid || 0,
    uname: opt.uname || '',
    avatar: opt.avatar || '',
    utime: opt.utime || '',
    to: opt.to || 0,
    pid: opt.pid || 0,
    callbackName: 'sendComment'
  })
}

/**
 * 加载标签或更多数据
 * @param {String} stockCode 股票代码
 * @param {Tag} tag 标签
 * @param {String} lastSeq 最后一个seq
 */
export function getListData (stockCode, tag, lastSeq) {
  return axios({
    url: getListDataUrl(stockCode || '', tag || '', lastSeq || '')
  })
}

/**
 * 加载更多 研报
 * @param {String} stockCode 股票代码
 * @param {Number} ts 最近的时间戳
 */
export function getReportListData (stockCode, ts) {
  return axios({
    url: getReportListDataUrl(stockCode || '', ts || '')
  })
}

/**
 * 加载更多 公告
 * @param {String} stockCode 股票代码
 * @param {Number} ts 最近的时间戳
 */
export function getNoticeListData (stockCode, ts) {
  return axios({
    url: getNoticeListDataUrl(stockCode || '', ts || '')
  })
}
